import ViewHabit from "./components/ViewHabit";
import HabitContainer from "./HabitContainer";
export default HabitContainer(ViewHabit);
